function pcxOrPtx(eltek_type: number): string {
  if (eltek_type === 5) return 'PCX';
  if (eltek_type === 7) return 'PTX';
  return null;
}

export default pcxOrPtx;
